import { useEffect, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import RouteMap from "@/components/RouteMap";

export default function BookingLocationMap({ booking }) {
  const [geo, setGeo] = useState(booking.lat != null ? { lat: booking.lat, lng: booking.lng, geo_precision: booking.geo_precision } : null);
  const [home, setHome] = useState(null);
  const [state, setState] = useState("idle");

  useEffect(() => {
    let alive = true;
    setState("loading");
    api
      .post(`/route/geocode/${booking.id}`)
      .then((r) => {
        if (!alive) return;
        setGeo(r.data);
        setHome(r.data.home);
        setState("ok");
      })
      .catch(() => alive && setState("error"));
    return () => {
      alive = false;
    };
  }, [booking.id]);

  return (
    <div className="cj-card p-4" data-testid="booking-location-map">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-[#ff6b00]" />
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">Location</div>
        </div>
        {geo?.geo_precision === "postcode" && <span className="cj-pill bg-amber-500/10 text-amber-300 border border-amber-500/30">Approx · postcode</span>}
        {booking.distance_km != null && <span className="font-mono text-xs text-slate-400">{booking.distance_km} km from base</span>}
      </div>
      {state === "loading" && !geo && <div className="flex items-center gap-2 text-sm text-slate-400"><Loader2 className="h-4 w-4 animate-spin" /> Locating…</div>}
      {state === "error" && !geo && <div className="text-sm text-amber-300" data-testid="booking-location-error">Couldn't place this address on the map.</div>}
      {geo && (
        <RouteMap
          home={home}
          stops={[{ id: booking.id, lat: geo.lat, lng: geo.lng, order: "•", customer_name: booking.customer.name, scheduled_time: booking.scheduled_time, service_name: booking.service_name, address: booking.customer.address, geo_precision: geo.geo_precision }]}
          showRoute={false}
          className="h-[260px]"
        />
      )}
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(booking.customer.address)}`}
        target="_blank"
        rel="noreferrer"
        data-testid="booking-open-in-maps"
        className="mt-3 inline-block text-xs font-display uppercase font-bold text-[#ff6b00] hover:text-[#ff8a2a]"
      >
        Open in Google Maps →
      </a>
    </div>
  );
}
